<generic-modal class="main-container report-selector-modal" #reportSelectorModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading>
		<div class="header-container">
			<div class="close-action">
				<button mat-button (click)="onClose()">
					<mat-icon>close</mat-icon>
				</button>
			</div>
			<div class="name-container">
				<span>Generate Inspection Report</span>
			</div>
			<h5 *ngIf="siteAddress">{{ siteAddress }}</h5>
		</div>
	</ng-template>
	<ng-template #modalBody>
		<div class="days-wrapper" [class.restricted]="displayAdditionalRecipients">
			<div *ngIf="allDates.length === 0 && !isLoading">
				<span *ngIf="onDemandFormCount > 0">No Inspection Dates Found!</span>
				<span *ngIf="onDemandFormCount === 0">
					No OnDemand Forms Configured. <br/> 
					Please contact Vitralogy or your System Administrator
				</span>
			</div>
      		<app-loader [hasTransparency]="true" [isInline]="false" [loaderMessage]="'Loading ...'"
						*ngIf="isLoading"></app-loader>
			<mat-radio-group
				class="summary-days"
				[(ngModel)]="selectedDay">
				<mat-radio-button class="summary-day" *ngFor="let item of allDates" [value]="item">
						<div class="day">
						  {{item.day | date: 'MM/dd/yy'}}
						</div>
						<div class="details">
						  {{item.totalCreated}} created / {{item.totalCompleted}} completed
						</div>
				</mat-radio-button>
			</mat-radio-group>
			<div class="actions" *ngIf="canLoadMoreData">
				<span (click)="loadNextPage()">more...</span>
			</div>
		</div>
		<div *ngIf="onDemandFormCount > 0" class="action">
			<span class="title" *ngIf="displayAdditionalRecipients">Additional Recipients 
				<span *ngIf="selectedAdditionalRecipients.length > 0" class="detail">({{selectedAdditionalRecipients.length}} selected)</span></span>
			<button mat-flat-button (click)="toggleAdditionalRecipients()"
			[disabled]="displayAdditionalRecipients"><mat-icon>add</mat-icon> Other Contacts</button>
		</div>
		<div *ngIf="displayAdditionalRecipients" class="additional-recipients">
			<div class="checkbox-group">
				<mat-checkbox style="margin-bottom: 5px;" *ngFor="let recipient of additionalRecipients"
					[checked]="isSelected(recipient.userAccountId)"
					(change)="toggleSelectedRecipient($event,recipient.userAccountId)" [class.mat-checkbox-disabled]="false"
					[disabled]="isLoading">
					{{ recipient.contactName }}</mat-checkbox>
			</div>
		</div>
	</ng-template>
	<ng-template #modalActions>
    <button mat-flat-button (click)="onClickGenerateReport()"
    [disabled]="!canGenerateReport()">Generate Report</button>
	</ng-template>
</generic-modal>